export const formatDate = (date, fallback = '') => {
  if (!date) {
    return fallback;
  }

  return new Date(date).toLocaleDateString();
};
